// extracted by mini-css-extract-plugin
export default {"page":"GO","freeShippingContainer":"HO","customizeContainer":"IO","customizeHeader":"JO","fadein":"KO","customizeText":"LO","hidden":"MO","productcard":"NO","accordeonscontainer":"OO","freeShipping":"PO","mainpart":"QO"};
    if(module.hot) {
      // 1714442370602
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  